exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n/*\n$navbar-default-bg: #312312;\n$light-orange: #ff8c00;\n$navbar-default-color: $light-orange;\n@import 'variables';\n@import '../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap';\n*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles